module.exports = __webpack_public_path__ + "img/main_3_3_3.8702a71e.png";